<button id="button-close" type="button" (click)="cerrarModal()" class="btn btn-raised btn-warning mr-1">
  <em class="ft-x"></em>
</button>
<iframe class="rowIframe" id="iframeReporteador" frameborder="0" type="text/html ">
</iframe>